<template>
  <label
    style="
      border-radius: 50%;
      overflow: hidden;
      padding: 100% 0 0 0;
      position: relative;
      display: block;
    "
  >
    <div class="person-avatar">
      <img
        :src="image_src"
        class="person-avata1r"
        style="width: 100%; position: absolute; left: 0; top: 0"
      />
    </div>
  </label>
</template>
<script>
export default {
  props: {
    url: String,
    image: String,
    type: String,
  },
  methods: {},
  computed: {
    image_src() {
      if (this.image_ !== false) return this.image_;
      else return this.image;
    },
  },
  data() {
    return {
      image_: false,
    };
  },
};
</script>
<style scoped="" lang="scss">
input.avatar-input {
  position: absolute;
  top: -10100px;
}
.person-avatar {
  border-radius: 50%;
}
</style>
